import { UserLevel } from './types';

export const categoryTitles = {
  [UserLevel.A1]: 'A1 ҚАРАПАЙЫМ ДЕҢГЕЙ',
  [UserLevel.A2]: 'A2 БАЗАЛЫҚ ДЕҢГЕЙ',
  [UserLevel.B1]: 'B1 ОРТА ДЕҢГЕЙ',
  [UserLevel.B2]: 'B2 ОРТАДАН ЖОҒАРЫ ДЕҢГЕЙ',
  [UserLevel.C1]: 'C1 ЖОҒАРЫ ДЕҢГЕЙ',
};
